import axios from 'axios'
import moment from 'moment'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getParkingAvailabilityRate(condition = {}) {
  let response = {}
  // let scenicAreaId = `areaid=` + (condition.scenicAreaId)+ "&";
  let scenicAreaIdQuery = "";

  if(condition.scenicAreaId === null) {
    scenicAreaIdQuery = "";
  }else{

    if(condition.scenicAreaId.length > 1) {
      const query = condition.scenicAreaId.map((scenicAreaId) => `scenicAreaIds=${scenicAreaId}`).join('&');
       scenicAreaIdQuery =  query;
  
    }else{
      scenicAreaIdQuery = `scenicAreaIds=${condition.scenicAreaId}`
    }
    
  }

  // let scenicAreaId =Utils.isEmptyObject(condition.scenicAreaId) ? '' : `areaid=${condition.scenicAreaId}&`;
  let warningLevel = condition.warningLevel;
  let warningLevelQuery = warningLevel.map(level => `warningLevel=${level}`).join('&');
  let passengerType = condition.passengerType ;
  let passengerTypeQuery =  passengerType === null ? '' : passengerType.map(type => `passengerType=${type}`).join('&');

  let startTime = encodeURIComponent(moment(condition.startTime).format().split('+')[0]) ;//2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = `&sttime=${startTime}`
  let endTime = encodeURIComponent(moment(condition.endTime).format().split('+')[0]); //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let endTimeQuery =`&endtime=${endTime}`

  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/ParkingAvailabilityRate/GetParkingAvailabilityRate?${scenicAreaIdQuery}&${warningLevelQuery}&${passengerTypeQuery}${startTimeQuery}${endTimeQuery}`)
  } catch (err) {
    console.error('iisi getAllControllHistory: ', err) 
  }

  Utils.setApiResponsSuccess(response)
  return response
}
